(() => {
  const trigger = document.querySelector('[data-tsg-reach-out]');
  const dialog = document.getElementById('TSGQuickDialog');
  if (!trigger || !dialog) return;
  const form = document.getElementById('TSGQuickContact');
  const storageKey = 'tsg-quick-enquiry-pending';
  const update = () => { trigger.hidden = window.scrollY < 240 || dialog.open; };
  const open = () => {
    if (dialog.open) return;
    dialog.showModal();
    trigger.setAttribute('aria-expanded', 'true');
    update();
    (dialog.querySelector('[data-tsg-quick-result]') || document.getElementById('TSGQuickTitle')).focus({preventScroll:true});
  };
  trigger.addEventListener('click', open);
  dialog.querySelector('[data-tsg-quick-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    trigger.setAttribute('aria-expanded', 'false');
    update();
    if (!trigger.hidden) trigger.focus({preventScroll:true});
  });
  window.addEventListener('scroll', update, {passive:true});
  window.addEventListener('pageshow', update);
  form.addEventListener('submit', () => {
    try { sessionStorage.setItem(storageKey, location.pathname); } catch (_) {}
  });
  let pending = false;
  try { pending = sessionStorage.getItem(storageKey) === location.pathname; } catch (_) {}
  const result = dialog.querySelector('[data-tsg-quick-result]');
  if (result && (pending || location.hash === '#TSGQuickContact')) {
    try { sessionStorage.removeItem(storageKey); } catch (_) {}
    open();
  }
  update();
})();
